import lvDirectory from './directive'

export default {
  install: function (Vue, opts = {}) {
    let { directiveName = 'directory' } = opts
    Vue.directive(directiveName, lvDirectory)
  }
}



// WEBPACK FOOTER //
// ./src/components/lv-directory/index.js